module.exports = __webpack_public_path__ + "fonts/8ce7dafe2009b62955173411031d079f.svg";